import React from 'react';
import { Grid, Card, CardContent, CardHeader, Button } from '@mui/material';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

const SPDResources = () => {
  return (
    <Grid container>
      <Grid item xs={12} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Resource Quick Links" />
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/e2bc1d16fe464ee6be6367b2da248831/latest"
                  label={'P.E.O. Constitution'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/47fe3df795cb4d819f6023869e9197a6/latest"
                  label={
                    'IOSC (Instructions to Officers of State/Provincial/District Chapters)'
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/ec63836b59d04d9f87d88ceb8c0fb65d/latest"
                  label={'List of Supplies for Officers of S/P/D Chapters'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/033416fea99749db976366fbf5910177/latest"
                  label={'Onboarding and Mentoring PowerPoint'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/77aec6aff3ed4597bf3ffe6d819bf371/latest"
                  label={'S/P/D Onboarding Roadmap'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/707ab4ae01094dfda76b41c06692a1d5/latest"
                  label={
                    'International Boards and Committees Onboarding Roadmap'
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/9e837e90979248379ecbb11087884932/latest"
                  label={'Small Board Onboarding Guide'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/c4fa13ee179b4cd7a1f1e27b3ae6336e/latest"
                  label={'S/P/D, Board or Committee Onboarding Template'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/3398ef431f884578909859bcd97fbdb9/latest"
                  label={'Onboarding Reflection Tool'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library"
                  label={'Search P.E.O. Resource Library on the Hub'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SPDResources;
